<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead
        :title="'Destination Towns'"
        :buttons="[
          {
            title: 'Add Town',
            icon: 'fa fa-plus',
            emit: 'add',
          },
        ]"
        @add="addShow = true"
      ></cardHead>
      <dataTable
        :name="'DestinationTowns'"
        ref="agGrid"
        :columnDefs="columnDefs"
        :data="data"
        @update="updateShow = $event"
        @remove="remove"
      ></dataTable>
      <upsert
        v-if="addShow || (updateShow != null && data != null)"
        :towns="data"
        :setModel="updateShow"
        @add="add"
        @update="update"
        :operators="data"
        @close="
          addShow = false;
          updateShow = null;
        "
      ></upsert>
    </div>
  </div>
</template>

<script>
import upsert from "./upsert";
export default {
  name: "DestinationTowns",
  components: { upsert },
  data() {
    return {
      columnDefs: [
        {
          headerName: "Id",
          width: 80,
          filter: "agNumberColumnFilter",
          field: "Id",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "SubId",
          width: 80,
          filter: "agNumberColumnFilter",
          field: "SubId",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Name",
          filter: "agTextColumnFilter",
          field: "Name",
          flex: 1,
          minWidth: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "SletatId",
          width: 120,
          filter: "agNumberColumnFilter",
          field: "SletatId",
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Country",
          filter: "agTextColumnFilter",
          field: "Name1",
          flex: 1,
          minWidth: 120,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "",
          type: "action",
          width: 75,
          buttons: [
            {
              classes: "btn btn-xs waves-effect waves-light btn-warning",
              text: '<i class="fas fa-pencil-alt"></i>',
              emit: "update",
            },
            {
              classes: "btn btn-xs waves-effect waves-light btn-danger",
              text: '<i class="fas fa-trash-alt"></i>',
              emit: "remove",
            },
          ],
          filter: false,
          sortable: false,
          resizable: false,
          floatingFilter: false,
        },
      ],
      data: null,
      addShow: false,
      updateShow: null,
    };
  },
  created() {
    this.$appAxiosAdmin.get(`DestinationTownsWithCountry`).then((response) => {
      this.data = response.data;
    });
  },
  methods: {
    update(item) {
      // $refs.agGrid.changeRow('Id',$event);
      this.$appAxiosAdmin
        .get(`DestinationTowns/` + item.Id)
        .then((response) => {
          this.$refs.agGrid.changeRow("Id", response.data[0]);
        });
    },
    add(item) {
      this.$appAxiosAdmin
        .get(`DestinationTowns/` + item.Id)
        .then((response) => {
          this.$refs.agGrid.addRow(response.data);
        });
    },
    remove(item) {
      this.$swal({
        icon: "question",
        title: "Warning!",
        text:
          "Are you sure you want to delete the destination town named " +
          item.Name +
          "?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .delete(`DestinationTowns/` + item.Id)
            .then(() => {
              this.$refs.agGrid.removeRow([item]);
              this.$swal({
                icon: "success",
                title: "Success",
                text: "The destination town has been successfully deleted.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>
